import { useEffect } from 'react';
import { redirectToCustomerLogin } from '../lib/sso';

// The training portal has no login UI of its own: /login always bounces to
// the customer-portal login, which SSO-returns the JWT to /auth/callback.
export default function LoginRedirect() {
  useEffect(() => {
    redirectToCustomerLogin();
  }, []);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-950 px-6 text-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary-500 border-t-transparent" />
      <p className="text-sm text-gray-400">Redirecting you to sign in…</p>
    </div>
  );
}
